import { BILLS_PATH, CONTRACTS_PATH, PACKING_LISTS_PATH } from "../constants";

export const checkTabPermission = (tabPath, permissions) => {
  if (tabPath === PACKING_LISTS_PATH && !permissions.viewPackingLists) return false;
  if (tabPath === BILLS_PATH && !permissions.viewBillsList) return false;
  if (tabPath === CONTRACTS_PATH && !permissions.viewContractsList) return false;
  return true;
};
